import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@/hooks/useAuth'
import Permission from '@/public/images/permission.svg'
import { getDefaultRouteForRole } from '@/utils/roleBasedRouting'

const UnauthorizedPage = () => {
  const navigate = useNavigate()
  const { data: user } = useCurrentUser()

  const handleGoBack = useCallback(() => {
    if (user?.roles) {
      const defaultRoute = getDefaultRouteForRole(user.roles)
      navigate(defaultRoute, { replace: true })
    } else {
      // If no user or roles (e.g. backend rejected), fully clear session via AuthProvider event
      // This prevents the infinite loop of navigating to login -> Clerk auto-redirects to / -> 403 back here
      globalThis.dispatchEvent(new Event('auth:logout'))
    }
  }, [user, navigate])

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-16">
      <section className="w-full max-w-xl rounded-2xl bg-white p-10 text-center shadow-lg">
        <img
          src={Permission}
          alt="Permission Denied"
          className="mx-auto h-[240px] w-[240px]"
        />
        <h1 className="text-2xl p-0 m-0 font-bold text-gray-900">
          Access restricted
        </h1>
        <p className=" text-md font-normal text-tertiary-600 m-0">
          You don't currently have access to this page. <br /> If you think you
          should have access, please reach out to your administrator.
        </p>
        <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={handleGoBack}
            variant="solid"
            color="primary"
            className="rounded-full px-4 py-3 text-sm"
          >
            Go back
          </Button>
        </div>
      </section>
    </main>
  )
}

export default UnauthorizedPage
